import type { AssignmentScope } from '@Application/Ai/AiConfiguration/Assignments/AssignmentScope';
import type { ModelAssignmentPayload } from '@Application/Ai/AiConfiguration/Assignments/Actions/modelAssignmentsFetched';

// Same shape as one entry of the `GET` response, for this single usage: the caller applies the
// result without a refetch.
export type ModelAssignmentSavedPayload = ModelAssignmentPayload;

export type ModelAssignmentSavedAction = {
	type: 'MODEL_ASSIGNMENT_SAVED';
	payload: ModelAssignmentSavedPayload;
	scope: AssignmentScope;
};

export default (
	payload: ModelAssignmentSavedPayload,
	scope: AssignmentScope,
): ModelAssignmentSavedAction => ({
	type: 'MODEL_ASSIGNMENT_SAVED',
	payload,
	scope,
});
